import { IAppState, IMembers } from '../../types/state.d';
import { PageInfo, PageType } from '../../../types/graphql';
import { apiActions, httpActions } from '..';

import { Action } from 'redux';
import { Auth } from '@justgiving/auth';
import { REQUEST } from '../../consts';
import { ThunkDispatch } from 'redux-thunk';
import config from '../../config';
import fetchLegacyMembersList from './fetchLegacyMembersList';
import fetchMembersListLeaderboards from './fetchLeaderboardsMembersList';
import { redirectByResponseStatus } from '../../utils';

export type MemberListItem = {
  numberOfMembers: number;
  members: IMembers;
  pageInfo: PageInfo;
};

export type MemberItem = {
  userGuid: string;
  firstName: string | null;
  lastName: string | null;
  profileImage: string | null;
  fundraisingPageGuid: string;
  fundraisingPageShortName: string;
  fundraisingPageName: string;
  pageUrl: string;
  pageType: PageType;
};

const toMembersListItem = (
  toMemberItem: IMembers,
  numberOfMembers: number,
  pageInfo: PageInfo,
): MemberListItem => {
  return {
    numberOfMembers: numberOfMembers,
    members: toMemberItem,
    pageInfo,
  };
};

const fetchMembersList = () => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.GET_MEMBERS_LIST;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    if (!config.features.useLeaderboarFundraisersListForTeams) {
      let res = await fetchLegacyMembersList(getState());
      dispatch(
        apiActions.saveMembersListData(
          toMembersListItem(res.members, res.numberOfMembers, res.pageInfo),
        ),
      );
    } else {
      let res = await fetchMembersListLeaderboards(getState());
      if (res) {
        dispatch(
          apiActions.saveMembersListData(
            toMembersListItem(res.members, res.numberOfMembers, res.pageInfo),
          ),
        );
      }
    }

    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error as Error));
    redirectByResponseStatus((error as any).status);
  }
};

export default fetchMembersList;
